import PSWApiClient from './PSWApiClient'
import { SwlsDriversClient } from './SwlsDriversClient'

class DriversAdapter {
  constructor(
    stack,
    clientId,
    pswApiClient = new PSWApiClient(stack, clientId),
    swlsDriversClient = new SwlsDriversClient()
  ) {
    this.pswApiClient = pswApiClient
    this.swlsDriversClient = swlsDriversClient
  }

  async fetchBasicDrivers({ sku }) {
    return this.pswApiClient.fetchBasicDrivers({ sku })
  }

  async getDriverDownloadUrl(sku, driverTypePreference) {
    return this.swlsDriversClient.getDriverDownloadUrl(
      sku,
      driverTypePreference
    )
  }

  async getDriverDownloadUrlByOS(os, easystartpro) {
    return this.swlsDriversClient.getDriverDownloadUrlByOS(os, easystartpro)
  }
}

export default DriversAdapter
